"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Month = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importDefault(require("react"));
const hooks_1 = require("../../../../../store/hooks");
const thresholdSlice_1 = require("../../../../../store/thresholdSlice");
const Day_1 = require("../Day");
const DayNamesHeader_1 = require("../DayNamesHeader");
const S = __importStar(require("./Month.style"));
const Month = ({ monthName, dayNamesHeader, weeks, onDayClick, selectedTimestamp, }) => {
    const thresholds = (0, hooks_1.useAppSelector)(thresholdSlice_1.selectThresholds);
    // Here we assume that each day object already has a date string in "YYYY-MM-DD" format.
    // This way we don’t rely on new Date() which uses the browser’s local timezone.
    const handleDayClick = (dateStr) => {
        if (!dateStr)
            return;
        // Parse the provided date string as UTC midnight.
        const convertedTimestamp = moment_timezone_1.default
            .utc(dateStr, "YYYY-MM-DD")
            .startOf("day")
            .add(1, "second")
            .valueOf();
        onDayClick(convertedTimestamp);
    };
    return (react_1.default.createElement(S.Month, null,
        react_1.default.createElement(S.MonthName, null, monthName),
        react_1.default.createElement(S.MonthContent, null,
            react_1.default.createElement(DayNamesHeader_1.DayNamesHeader, { dayNamesHeader: dayNamesHeader }),
            weeks.map((week) => (react_1.default.createElement(S.Week, { key: week[0].date }, week.map((day) => {
                // Compute the UTC midnight timestamp for comparison.
                const dayTimestamp = moment_timezone_1.default
                    .utc(day.date, "YYYY-MM-DD")
                    .startOf("day")
                    .add(1, "second")
                    .valueOf();
                return (react_1.default.createElement(Day_1.Day, Object.assign({ key: day.date }, day, thresholds, { 
                    // Use the day.date string directly.
                    onClick: () => handleDayClick(day.date), isSelected: selectedTimestamp !== null &&
                        dayTimestamp === selectedTimestamp })));
            })))))));
};
exports.Month = Month;
